import { focusRing } from "@m/alchemy-theme";
import styled from "styled-components";
export const MenuList = styled.ul `
  padding: 0;
  position: relative;
  margin: 0;

  [data-whatinput="keyboard"] &:focus {
    ${focusRing({ type: "inner" })};
  }
`;
